__turbopack_context__.v({
  "accordionLayout": "LabTestAccordionSection-module__1YTlTa__accordionLayout",
  "chip": "LabTestAccordionSection-module__1YTlTa__chip",
  "chipContainer": "LabTestAccordionSection-module__1YTlTa__chipContainer",
  "column": "LabTestAccordionSection-module__1YTlTa__column",
  "heading": "LabTestAccordionSection-module__1YTlTa__heading",
  "para": "LabTestAccordionSection-module__1YTlTa__para",
  "root": "LabTestAccordionSection-module__1YTlTa__root" + " " + __turbopack_context__.i(296195)["sectionPadding"],
  "separator": "LabTestAccordionSection-module__1YTlTa__separator",
  "subtitle": "LabTestAccordionSection-module__1YTlTa__subtitle",
  "title": "LabTestAccordionSection-module__1YTlTa__title",
});
